var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navigation-error"},[(_vm.isRedirecting)?_c('SpinnerLoader',{attrs:{"size":48}}):_c('ActionableHelperView',{attrs:{"on-retry":_vm.redirectToPreviousPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }